<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/backend/">
        <icon name="dashboard" class="mr-2 w-4 h-4" :class="isUrl('/backend/') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/backend/') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Übersicht</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/backend/report">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('/backend/report') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/backend/report') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Meldungen</div>
      </Link>
    </div>



    <div v-if="isAdmin" class="mb-4">
      <Link class="group flex items-center py-3" href="/backend/status">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('/backend/status') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/backend/status') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Status</div>
      </Link>
    </div>
    <div v-if="isAdmin" class="mb-4">
      <Link class="group flex items-center py-3" href="/backend/category">
        <icon name="office" class="mr-2 w-4 h-4" :class="isUrl('/backend/category') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'" />
        <div :class="isUrl('/backend/category') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Kategorie</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link, usePage } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  computed: {
    isAdmin() {
      const page = usePage()
      console.log(page.props.auth)
      return(true)
    },
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
